import React, { useContext, useEffect, useReducer } from 'react';
import { ContentContext } from 'layout/admin/content/Content';
import { api, process } from 'common/functions';
import produce from 'immer';
import Forbidden from './Forbidden/Forbidden';
import './CustomFieldContent.scss';
import { CustomFieldProvider } from './context/CustomFieldContext';
import Custom from './custom/Custom';

export type Module = {
  custom_field: boolean;
};

type Action = { type: 'module'; payload: Module };
type State = { module: Module };

const initialState: State = {
  module: { custom_field: false },
};

const reducer = (state: State, action: Action) => {
  return produce(state, (draft) => {
    // prettier-ignore
    switch (action.type) {
      case 'module': draft['module'] = action.payload; break;
    }
  });
};

const CustomFieldContent = () => {
  const { setLoading } = useContext(ContentContext);
  const [state, setState] = useReducer(reducer, initialState);

  const loadHandler = async () => {
    setLoading(true);
    process(
      api.reqData({ url: 'modules' }),
      api.get.request,
      api.fullFilled(({ response }) => {
        if (response) {
          const { module } = response.data;
          setState({ type: 'module', payload: module });
          setLoading(false);
        }
      })
    );
  };

  useEffect(() => {
    loadHandler();
  }, []);

  const { module } = state;
  const disabled = !module.custom_field;

  return (
    <div id="admin-manage-customfield-content">
      {disabled ? (
        <Forbidden />
      ) : (
        <CustomFieldProvider>
          <Custom />
        </CustomFieldProvider>
      )}
    </div>
  );
};

export default CustomFieldContent;
